import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-carousel-team-home',
  templateUrl: './carousel-team-home.component.html',
  styleUrls: ['./carousel-team-home.component.css']
})
export class CarouselTeamHomeComponent implements OnInit {

  @Input() carouselTeamHome_items: any = [];

  isLoaded: boolean = false;

  groupedItems: any;

  slides: any = {
    groups: 0,
    remainder: 0
  }

  constructor() { }


  ngOnInit(): void {
    // Verificar que carouselTeamHome_items existe y no está vacío
    if (!this.carouselTeamHome_items || this.carouselTeamHome_items.length === 0) {
      this.carouselTeamHome_items = [];
      this.slides.groups = 0;
      this.slides.remainder = 0;
      this.groupedItems = [];
      this.isLoaded = true;
      return;
    }

    const result = this.divideIntoGroups(this.carouselTeamHome_items);
    this.slides.groups = result.groups;
    this.slides.remainder = result.remainder;

    this.groupedItems = this.getGroupedItems()

    this.carouselTeamHome_items.forEach(item => {
      if (item && item.imgHomeUrl && !item.imgHomeUrl.startsWith('https://')) {
        item.imgHomeUrl = 'https://' + item.imgHomeUrl;
      }
    });

    this.isLoaded = true;

  }

  getGroupedItems(): any[][] {
    let grouped: any[][] = [];
    for (let i = 0; i < this.carouselTeamHome_items.length; i += 4) {
      let group = this.carouselTeamHome_items.slice(i, i + 4);
      
      // Si el grupo tiene menos de 4 elementos, reorganizar para que los vacíos estén abajo
      if (group.length < 4) {
        let reorderedGroup = new Array(4);
        
        // Llenar desde arriba hacia abajo
        for (let j = 0; j < group.length; j++) {
          reorderedGroup[j] = group[j];
        }
        
        group = reorderedGroup;
      }
      
      grouped.push(group);
    }
    return grouped;
  }


  divideIntoGroups(arr: any[]): { groups: number, remainder: number } {
    const totalGroups = Math.ceil(arr.length / 4);
    const remainder = (4 - (arr.length % 4)) % 4;  // Calcula cuántos elementos faltan para completar 4

    return {
      groups: totalGroups,
      remainder: remainder
    };
  }

}
